import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCardModule as MatCardModule } from "@angular/material/card";
import { MatButtonModule as MatButtonModule } from "@angular/material/button";
import { MatInputModule as MatInputModule } from "@angular/material/input";
import { MatFormFieldModule as MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatListModule as MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule as MatTableModule } from "@angular/material/table";
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatPaginatorModule as MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatMenuModule as MatMenuModule } from "@angular/material/menu";
import { MatRadioModule as MatRadioModule } from "@angular/material/radio";
import { MatTooltipModule as MatTooltipModule } from "@angular/material/tooltip";
import { MatSelectModule as MatSelectModule } from "@angular/material/select";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatCheckboxModule as MatCheckboxModule } from "@angular/material/checkbox";
import { MatTreeModule } from "@angular/material/tree";
import { MatDialogModule } from "@angular/material/dialog";
import { DragDropModule } from "@angular/cdk/drag-drop";

@NgModule({
  imports: [
    CommonModule,
    MatToolbarModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatGridListModule,
    MatListModule,
    MatSidenavModule,
    MatIconModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    DragDropModule,
    MatRadioModule,
    MatTooltipModule,
    MatSelectModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTreeModule,
    MatDialogModule,
  ],
  exports: [
    MatToolbarModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatGridListModule,
    MatListModule,
    MatSidenavModule,
    MatIconModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    DragDropModule,
    MatMenuModule,
    MatRadioModule,
    MatTooltipModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTreeModule,
    MatDialogModule,
  ],
})
export class AppMaterialModule {}
